export default "__VITE_ASSET__B6jJdIKr__"